import React, {
  useEffect,
  useMemo,
  useState,
} from 'react';
import Modal from '@mui/material/Modal';
import {
  Box,
  Button,
} from '@mui/material';
import { DateRangePicker } from 'rsuite';
import { DateRange } from 'rsuite/esm/DateRangePicker';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { Cancel } from '../../media/images/Cancel';
import { AnalystTubeCountDatatablestyle } from './utils/Constant';
import { predefinedRanges } from '../../Common/SearchHeader/utils/DatePickerRange';
import { RootState } from '../../redux/rootState';
import { setLoader } from '../../redux/loaderSlice';
import { getAnalystTubeCountReport } from './redux/dashboardSlice';

interface IAnalystTubeCountModal {
  open: boolean;
  handleClose: () => void;
  handleReportDisplay: () => void;
}

export default function AnalystSelfTubeCountModal({
  open, handleClose, handleReportDisplay,
}: IAnalystTubeCountModal) {
  const dispatch = useDispatch();
  const [dateOpen, setDateOpen] = useState(false);
  const [dateRange, setDateRange] = useState<DateRange | null>(null);
  const handleDateChange = (value: DateRange | null) => {
    setDateRange(value);
  };
  const { isLoading } = useSelector((state: RootState) => state.bidsReducer);
  const { userProfile } = useSelector((state: RootState) => state.userProfileReducer);
  const { isAnalystTubeRepLoading } = useSelector((state: RootState) => state.dashboardReducer);

  useEffect(() => {
    if (isLoading || isAnalystTubeRepLoading) {
      dispatch(setLoader(true));
    } else {
      dispatch(setLoader(false));
    }
  }, [isLoading, isAnalystTubeRepLoading]);

  const closeModal = () => {
    setDateRange(null);
    handleClose();
  };
  const successCallback = () => {
    handleReportDisplay();
    closeModal();
  };

  const isButtonEnabled = useMemo(() => dateRange, [dateRange]);

  const handleReport = () => {
    if (isButtonEnabled) {
      const StartDate = dayjs(dateRange?.[0])?.format('DD-MM-YYYY');
      const EndDate = dayjs(dateRange?.[1])?.format('DD-MM-YYYY');
      const AnalystIds = [] as string[];
      const Email = userProfile?.Email;

      const payload = {
        StartDate, EndDate, AnalystIds, Email, IsAnalyst: true,
      };
      dispatch(getAnalystTubeCountReport({ pay: payload, callback: successCallback }));
    }
  };

  return (
    <Modal
      open={open}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={AnalystTubeCountDatatablestyle}>
        <div className="customerInfo_container flex-row">
          <div className="customerInfo">
            Analyst Tube Count
          </div>
          <div className="cancel-icon" onClick={() => closeModal()}>
            <Cancel />
          </div>
        </div>
        <div className="analystTubeCountModalHeaderRowAlign">
          <div className="dateRangeFilterRangeDatePicker">
            <p className="analystModalLabel">Select Date Range</p>
            <DateRangePicker
              name="Range"
              open={dateOpen}
              onClick={() => setDateOpen(!dateOpen)}
              onOk={() => setDateOpen(false)}
              value={dateRange}
              onChange={handleDateChange}
              ranges={predefinedRanges}
              placeholder="Date Range"
              className="dateRangeFilterCustomDateRangeCalender"
              character=" - "
              showCleanButton
              format="MM-dd-yyyy"
              placement="bottomStart"
            />
          </div>

          <Button
            className={isButtonEnabled ? 'button_save_and_next' : 'button_cancel cursorNotAllowed'}
            sx={{ height: 36, marginTop: '20px' }}
            onClick={handleReport}
          >
            Get Tube Count
          </Button>
        </div>
      </Box>
    </Modal>
  );
}
